// extracted by mini-css-extract-plugin
module.exports = {"iframe":"audio-module--iframe--2F3rT"};